import ModemAlert from '../../../../components/ModemAlert';
import OrderDetailsSection from '../OrderDetailsSection';
import TermsAndConditions from '../TermsAndConditions';

import { ModalTypes } from '../../../../types';

interface NoticeProps {
  openModal: (e: React.MouseEvent<HTMLElement>, modalType: ModalTypes) => void;
  closeModal: () => void;
  isModalOpen: boolean;
}

const Notice = ({ openModal, closeModal, isModalOpen }: NoticeProps) => {
  return (
    <OrderDetailsSection id="modem-reboot">
      <ModemAlert />
      <TermsAndConditions
        openModal={openModal}
        closeModal={closeModal}
        isModalOpen={isModalOpen}
      />
    </OrderDetailsSection>
  );
};

export default Notice;
